import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import APP from 'app'

import AppVersion from '../ui/AppVersion'
import PostList from './PostList'
import PostAdd from './posts/PostAdd'

class Wall extends PureComponent {
  render() {
    const { active, add, device, isAdmin, owner, type, viewer, wall } = this.props
    const canUseWall = ['institution', 'sports_soccer_match', 'stats', 'user'].includes(type)
    return (
      <div className="Wall flex flex-col gap-1">
        {canUseWall && add && <PostAdd owner={owner} type={type} viewer={viewer} wall={wall} />}
        <AppVersion mobile={device.mobile} os={device.os} version={APP.device.appVersion} />
        {canUseWall && <PostList active={active} isAdmin={isAdmin} owner={owner} type={type} wall={wall} />}
      </div>
    )
  }
}

Wall.propTypes = {
  device: PropTypes.object.isRequired,
  owner: PropTypes.object.isRequired,
  type: PropTypes.oneOf([
    'advertising',
    'institution',
    'sports_soccer_match',
    'sports_soccer_team',
    'sports_tournament',
    'stats',
    'user',
  ]).isRequired,

  active: PropTypes.bool,
  add: PropTypes.bool,
  isAdmin: PropTypes.bool,
  viewer: PropTypes.object,
  wall: PropTypes.bool,
}

Wall.defaultProps = {
  active: true,
  add: false,
  isAdmin: false,
  viewer: null,
  wall: false,
}

export default connect(({ auth: { usr: user }, environment: { device } }) => ({
  device,
  user,
}))(Wall)
